export default "__VITE_ASSET__M4tUGKrW__"